var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59766 6H16.931",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59766 9.3335V14.3335",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9336 9.3335V14.3335",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43359 6L5.26693 16C5.26693 16.442 5.44252 16.866 5.75508 17.1785C6.06764 17.4911 6.49157 17.6667 6.93359 17.6667H13.6003C14.0423 17.6667 14.4662 17.4911 14.7788 17.1785C15.0913 16.866 15.2669 16.442 15.2669 16L16.1003 6",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76562 6.00008V3.50008C7.76562 3.27907 7.85342 3.06711 8.0097 2.91083C8.16598 2.75455 8.37794 2.66675 8.59896 2.66675H11.9323C12.1533 2.66675 12.3653 2.75455 12.5215 2.91083C12.6778 3.06711 12.7656 3.27907 12.7656 3.50008V6.00008",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.c54f82b0c8855d2ce092610afb96f9aa.svg";
export { ForwardRef as ReactComponent };